"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _class, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var PropTypes = require("prop-types");

var React = require("react");

var classnames = require("classnames");

module.exports = (_temp = _class = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(_class, _React$Component);

  var _super = _createSuper(_class);

  function _class() {
    (0, _classCallCheck2.default)(this, _class);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(_class, [{
    key: "render",
    value: function render() {
      var prop = this.props;
      var prevClassName = classnames("icon", {
        disabled: this.props.prevDisabled
      });
      var nextClassName = classnames("icon", {
        disabled: this.props.nextDisabled
      });
      return /*#__PURE__*/React.createElement("div", {
        "data-id": this.props["data-id"],
        className: "navigation-wrapper"
      }, /*#__PURE__*/React.createElement("span", {
        onClick: this.props.prevDisabled ? null : prop.onPrev,
        className: prevClassName,
        "data-id": "view-header_previous"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-left icon-left",
        "data-id": "calendar-nav-icon-left"
      })), /*#__PURE__*/React.createElement("span", {
        onClick: prop.onClick,
        className: "navigation-title",
        "data-id": "view-header_title"
      }, prop.data), /*#__PURE__*/React.createElement("span", {
        onClick: this.props.nextDisabled ? null : prop.onNext,
        className: nextClassName,
        "data-id": "view-header_next"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-right icon-right",
        "data-id": "calendar-nav-icon-right"
      })));
    }
  }]);
  return _class;
}(React.Component), (0, _defineProperty2.default)(_class, "propTypes", {
  "data-id": PropTypes.string,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  onClick: PropTypes.func,
  data: PropTypes.string,
  prevDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool
}), (0, _defineProperty2.default)(_class, "defaultProps", {
  "data-id": "view-header"
}), _temp);